import React from 'react'

export default ({ color }) => (
  <svg width="48px" height="54px" viewBox="0 0 47 53">
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="SideBySide" transform="translate(-490.000000, 0.000000)" fill={color}>
        <g id="NumberChevron-Down" transform="translate(490.000000, 0.000000)">
          <polygon id="Path" points="0 0 0 33.538314 23.5 53 47 33.538314 47 0" />
        </g>
      </g>
    </g>
  </svg>
)
